import { __decorate, __metadata } from "tslib";
import { containerResolver } from '../protocol/resolver';
/**
 * Used to inject the dependency from the parent container instead of the current one.
 */
var ParentResolver = /** @class */ (function () {
    /**
     * Creates an instance of the Parent class.
     * @param key The key to resolve from the parent container.
     */
    function ParentResolver(key) {
        this._key = key;
    }
    ParentResolver_1 = ParentResolver;
    /**
     * Creates a Parent Resolver for the supplied key.
     * @param key The key to resolve.
     * @return Returns an instance of Parent for the key.
     */
    ParentResolver.of = function (key) {
        return new ParentResolver_1(key);
    };
    /**
     * Called by the container to load the dependency from the parent container
     * @param container The container to resolve the parent from.
     * @return Returns the matching instance from the parent container
     */
    ParentResolver.prototype.get = function (container) {
        return container.parent ? container.parent.get(this._key) : null;
    };
    var ParentResolver_1;
    ParentResolver = ParentResolver_1 = __decorate([
        containerResolver,
        __metadata("design:paramtypes", [Object])
    ], ParentResolver);
    return ParentResolver;
}());
export { ParentResolver };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGFyZW50UmVzb2x2ZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJQYXJlbnRSZXNvbHZlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBT0EsT0FBTyxFQUFFLGlCQUFpQixFQUFFLE1BQU0sc0JBQXNCLENBQUM7QUFHekQ7O0dBRUc7QUFFSDtJQWFJOzs7T0FHRztJQUNILHdCQUFtQixHQUFXO1FBQzFCLElBQUksQ0FBQyxJQUFJLEdBQUcsR0FBRyxDQUFDO0lBQ3BCLENBQUM7dUJBbkJRLGNBQWM7SUFDdkI7Ozs7T0FJRztJQUNXLGlCQUFFLEdBQWhCLFVBQW9CLEdBQVc7UUFDM0IsT0FBTyxJQUFJLGdCQUFjLENBQUksR0FBRyxDQUFDLENBQUM7SUFDdEMsQ0FBQztJQWFEOzs7O09BSUc7SUFDSSw0QkFBRyxHQUFWLFVBQVcsU0FBb0I7UUFDM0IsT0FBTyxTQUFTLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxTQUFTLENBQUMsTUFBTSxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQztJQUNyRSxDQUFDOztJQTVCUSxjQUFjO1FBRDFCLGlCQUFpQjs7T0FDTCxjQUFjLENBNkIxQjtJQUFELHFCQUFDO0NBQUEsQUE3QkQsSUE2QkM7U0E3QlksY0FBYyJ9